// Polyfill Promise.withResolvers for older browsers (Chrome <119, Firefox <121)
// Required by pdfjs-dist v5.x used by react-pdf v10
// Must be imported before any module that uses Promise.withResolvers

export {};

interface PromiseWithResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
}

declare global {
  interface PromiseConstructor {
    withResolvers<T>(): PromiseWithResolvers<T>;
  }
}

if (typeof Promise.withResolvers !== "function") {
  Object.defineProperty(Promise, "withResolvers", {
    value: <T>(): PromiseWithResolvers<T> => {
      let resolve: (value: T | PromiseLike<T>) => void;
      let reject: (reason?: unknown) => void;
      const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve: resolve!, reject: reject! };
    },
    configurable: true,
    writable: true,
  });
}
